import Component from '@glimmer/component';

export default class DeluxePlayerMiniPlayerControlsComponent extends Component {}
